import {createFeatureSelector, createSelector} from "@ngrx/store";
import {notificationsFeatureKey, NotificationsState} from "./notifications.reducer";
import {SelectorUtil} from "@app-web-central/web/shared/utils";

export const getNotificationsState = createFeatureSelector<NotificationsState>(notificationsFeatureKey);
export const getNotifications = createSelector(getNotificationsState, (state) => state.notifications || []);
export const getReminder = createSelector(getNotificationsState, (state) => state.reminder);

export const getNotificationsLoading = createSelector(getNotificationsState, SelectorUtil.isLoading);
